import styled from 'styled-components/macro'

import { Table } from '@loadsmart/loadsmart-ui'
import { toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

import { Icon } from 'core/ui/components/icon/Icon'

import { screen } from 'legacy/styles/screen'

export const ChargesStyledTable = styled(Table)`
  .desktop-view-only {
    display: none;
  }

  ${screen.md} {
    .desktop-view-only {
      display: table-cell;
    }
  }
`

export const AttachmentLink = styled.a`
  align-items: center;
  display: flex;
  gap: ${toCSSValue('spacing-1')};
`

export const AttachmentContainer = styled.span`
  ${screen.md} {
    padding-left: ${toCSSValue('spacing-8')};
  }
  ${screen.lg} {
    padding-left: ${toCSSValue('spacing-10')};
  }
`

export const LinkIcon = styled(Icon)`
  color: ${toCSSValue('color-text-link')};
`
